export default class {
  constructor () {
    this.$calendarSection = document.querySelector('.calendar')
    this.$calendarContent = this.$calendarSection.querySelector('.calendar__content')
    this.$calendarOverlay = this.$calendarSection.querySelector('.calendar__overlay')

    this.isActive = false

    this.bindEvents()
  }

  bindEvents () {
    this.$calendarContent.addEventListener('click', this.onClickSectionHandler.bind(this))
    this.$calendarOverlay.addEventListener('click', this.onClickOverlayHandler.bind(this))
  }

  onClickSectionHandler () {
    this.$calendarSection.classList.add('active')
  }

  onClickOverlayHandler () {
    this.$calendarSection.classList.remove('active')
  }
}
